/* =====================================================================
   lz-chrome.js — lo minimo que necesita el header/footer de Linfozen
   fuera de la landing (contacto y las cuatro politicas).

   Por que no se carga lz-app.js aca: son 32 KB que resuelven cosas que
   en estas paginas no existen (selector de packs, explorador de
   ingredientes, popups, reviews, barras fijas, sliders). De todo eso el
   header y el footer solo dependen de dos comportamientos, y son estos.
   El carrito sigue siendo lz-cart.js, que ya es autonomo.

     1. --real-vh   la gaveta del carrito la usa en .cart-content; sin la
                    variable la regla height: var(--real-vh) es invalida
                    y el drawer se queda sin alto.
     2. countdown   el banner del anuncio trae 01:59:29 escrito en el
                    HTML. Sin JS queda congelado, que se ve peor que no
                    tenerlo. Misma logica y mismos data-* que
                    initBannerTimer() de lz-app.js.
   ===================================================================== */
(function () {
  'use strict';

  /* ---- 1. alto real de la ventana ---------------------------------- */

  function syncViewportHeight() {
    document.documentElement.style.setProperty('--real-vh', window.innerHeight + 'px');
  }

  var vhTimer = null;
  function syncViewportHeightDebounced() {
    if (vhTimer) clearTimeout(vhTimer);
    vhTimer = setTimeout(syncViewportHeight, 150);
  }

  syncViewportHeight();
  window.addEventListener('resize', syncViewportHeightDebounced, { passive: true });
  window.addEventListener('orientationchange', syncViewportHeight, { passive: true });

  /* ---- 2. contador del banner -------------------------------------- */

  function pad(value) {
    return String(Math.max(0, Math.floor(value))).padStart(2, '0');
  }

  function to24Hour(hour12, period) {
    var h = hour12 % 12;
    return (period || 'pm').toLowerCase() === 'pm' ? h + 12 : h;
  }

  function nextDailyReset(hour12, minute, period) {
    var now = new Date();
    var next = new Date(now);
    next.setHours(to24Hour(hour12, period), minute, 0, 0);
    if (next.getTime() <= now.getTime()) next.setDate(next.getDate() + 1);
    return next.getTime();
  }

  function initBannerTimer(timer) {
    var sectionId = timer.id.replace(/^countdown-/, '');
    var hoursEl = document.getElementById('hh-' + sectionId);
    var minutesEl = document.getElementById('mm-' + sectionId);
    var secondsEl = document.getElementById('ss-' + sectionId);
    if (!hoursEl || !minutesEl || !secondsEl) return;

    function toInt(attr, fallback) {
      var parsed = parseInt(timer.getAttribute(attr), 10);
      return isNaN(parsed) ? fallback : parsed;
    }

    var isDaily = (timer.getAttribute('data-reset-mode') || 'refresh_reset') === 'daily_reset_time';

    function dailyTarget() {
      return nextDailyReset(
        toInt('data-daily-hour', 9),
        toInt('data-daily-minute', 0),
        timer.getAttribute('data-daily-period') || 'pm'
      );
    }

    var target = isDaily ? 0 : Date.now() + (
      toInt('data-duration-hours', 2) * 3600 +
      toInt('data-duration-minutes', 0) * 60 +
      toInt('data-duration-seconds', 0)
    ) * 1000;

    function tick() {
      var diff = (isDaily ? dailyTarget() : target) - Date.now();
      if (diff < 0) diff = 0;
      var total = Math.floor(diff / 1000);
      hoursEl.textContent = pad(total / 3600);
      minutesEl.textContent = pad((total % 3600) / 60);
      secondsEl.textContent = pad(total % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initTimers() {
    var timers = document.querySelectorAll('.countdown-timer[id^="countdown-"]');
    for (var i = 0; i < timers.length; i++) initBannerTimer(timers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimers);
  } else {
    initTimers();
  }
})();
